export const Logger = {
  log: (message: string, params?: any) => {
    // TODO: Maybe we will show some errors in future
    console.log(message, params);
  },
};
